/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ItemQueryResult from './ItemQueryResult';

/**
 * The ItemOutputCmsItem model module.
 * @module model/ItemOutputCmsItem
 * @version 1.0
 */
class ItemOutputCmsItem {
    /**
     * Constructs a new <code>ItemOutputCmsItem</code>.
     * @alias module:model/ItemOutputCmsItem
     */
    constructor() { 
        
        ItemOutputCmsItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ItemOutputCmsItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemOutputCmsItem} obj Optional instance to populate.
     * @return {module:model/ItemOutputCmsItem} The populated <code>ItemOutputCmsItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemOutputCmsItem();

            if (data.hasOwnProperty('item')) {
                obj['item'] = ItemQueryResult.constructFromObject(data['item']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/ItemQueryResult} item
 */
ItemOutputCmsItem.prototype['item'] = undefined;






export default ItemOutputCmsItem;

